import { render, staticRenderFns } from "./ReviewForm.vue?vue&type=template&id=5a1671fd&scoped=true&"
import script from "./ReviewForm.vue?vue&type=script&lang=ts&"
export * from "./ReviewForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewForm.vue?vue&type=style&index=0&id=5a1671fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1671fd",
  null
  
)

export default component.exports